module.exports = __webpack_public_path__ + "img/cast.f63a2888.svg";